import React, { useState, useEffect, useRef } from "react";

interface SubMenuProps {
  children: React.ReactNode;
  triggerRef: React.RefObject<HTMLElement>;
}

const SubMenu: React.FC<SubMenuProps> = ({ children, triggerRef }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const submenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (triggerRef.current && submenuRef.current) {
      const triggerRect = triggerRef.current.getBoundingClientRect();
      const submenuWidth = submenuRef.current.offsetWidth;

      setPosition({
        top: triggerRect.bottom + window.scrollY,
        left: triggerRect.right + window.scrollX - submenuWidth,
      });
    }
  }, [triggerRef]);

  return (
    <div
      ref={submenuRef}
      className="absolute z-50 w-fit rounded-md bg-white"
      style={{ top: `${position.top}px`, left: `${position.left}px` }}
    >
      {children}
    </div>
  );
};

export default SubMenu;
